export default {
  token: localStorage.getItem('token') || null,
  user: {
    name: '',
    role: ''
  },
  message: null,
  error: null
  
}